import React from 'react';

const Footer = () => {
	return (
		<footer className="border-t border-border bg-warm">
			<div className="max-w-6xl mx-auto px-6 sm:px-16 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
				<p className="text-muted text-[14px]">
					&copy; {new Date().getFullYear()} Sachin Saurav. All rights reserved.
				</p>
				<div className="flex items-center gap-2">
					<kbd className="inline-flex items-center px-2 py-0.5 bg-surface border border-border rounded text-[11px] text-muted font-mono">
						&#8984;K
					</kbd>
					<span className="text-muted text-[13px]">to navigate</span>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
